import { Base, PageObject } from '@testsigmainc/models';
import {
  alias,
  deserialize,
  list,
  object,
  optional,
  serializable,
} from 'serializr';
import { Browser } from '@models/browser.model';
import { FigmaTeam } from './figma-team.model';

export class ExternalApplicationMetaData extends Base implements PageObject {
  @serializable
  public channel: string;
  @serializable
  public user_name: string;
  @serializable
  public web_enabled: boolean;
  @serializable
  public android_enabled: boolean;
  @serializable
  public ios_enabled: boolean;
  @serializable
  public region: string;
  @serializable
  public is_authentication_enabled: boolean;
  @serializable(alias('browserList', optional(list(object(Browser)))))
  public browsers: Browser[];
  deserialize(input: any): this {
    return Object.assign(this, deserialize(ExternalApplicationMetaData, input));
  }
}
